// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'
import getSiteValues from '../getSiteValues'
import Cell from './Cell'

const FormatAntenna = props => {
  const {
    columnKey,
    idRoot,
    rowData,
    TooltipTrigger,
  } = props

  const {
    site1Value,
    site2Value,
  } = getSiteValues(columnKey, rowData)

  return (
    <div className={'path-summary-cell display-flex'}>
      <Cell
        columnKey={columnKey}
        label={'site-1-antenna'}
        idr={`${idRoot}-site-1-`}
        TooltipTrigger={TooltipTrigger}
        {...site1Value} />
      <Cell
        columnKey={columnKey}
        label={'site-2-antenna'}
        idr={`${idRoot}-site-2-`}
        TooltipTrigger={TooltipTrigger}
        {...site2Value} />
    </div>
  )
}

FormatAntenna.propTypes = {
  columnKey: string.isRequired,
  idRoot: string.isRequired,
  rowData: object.isRequired,
  TooltipTrigger: func.isRequired,
}

export default FormatAntenna
